var SCORM = window.SCORM || {};

SCORM.SCORM_API = require('./scormsingleproto');

window.SCORM = SCORM;